import Container from '@/components/container/Container';
import { Dropdown, type DropdownChangeEvent } from 'primereact/dropdown';
import { useState } from 'react';
import flagStyles from './flags.module.css';
import './select-dropdown.styles.css';
import FlagsModel, { Flag } from '@/modules/authentication/sign-up/components/CountryFlags';
import { cn } from '@/components/ui/cn';

interface Props {
	value?: string;
	onChange: (countryCode: string) => void;
}


const SelectCountryDropdown = (props: Props) => {
	const defaultFlag: Flag = {
		name: 'Philippines',
		code: 'PH',
		dialCode: '+63',
	};

	const [selectedCountry, setSelectedCountry] = useState<Flag | null>(defaultFlag);

	const isControlled = props.value !== undefined;
	const controlledFlag = isControlled ? (FlagsModel.flagByCountryCode(props.value as string) ?? defaultFlag) : null;
	const dropdownValue = isControlled ? controlledFlag : selectedCountry;

	const countryOptionTemplate = (option: Flag) => {
		// if (!option.countryCode) {
		// 	console.log("Wrong option " + option);
		// }
		return (
			<Container className="country-option">
				<img
					alt={option.name}
					src="/images/flag-placeholder.png"
					className={cn('mr-2', flagStyles['flag'], flagStyles[`flag-${option.code?.toLowerCase() ?? ''}`])}
				/>
				<div>
					{option.name} {option.dialCode}
				</div>
			</Container>
		);
	};

	return (
		<Dropdown
			value={dropdownValue}
			onChange={(e: DropdownChangeEvent) => {
				const nextFlag = e.value as Flag;
				if (!isControlled) {
					setSelectedCountry(nextFlag);
				}
				props.onChange(nextFlag.code);
			}}
			options={FlagsModel.countries}
			optionLabel="name"
			valueTemplate={countryOptionTemplate}
			itemTemplate={countryOptionTemplate}
			className="country-dropdown default-dropdown"
		/>
	);
};

export default SelectCountryDropdown;
